function UserLevels() {
    return (
      <>
        <div className="font-bold text-lg mb-16">UserLevels</div>
      </>
    );
  }
  
  export default UserLevels;